import router from '@/router/router';
import axios from '@/axios';
import theApi from '@/mixins/theApi';
import store from '@/store/store';

export default {
  /***
   *  LOGIN FUNCTIONS
   */
  async login(context, payload) {
    let formData = new FormData();
    formData.append('email', payload.email);
    formData.append('password', payload.password);

    theApi.methods.makeCall(false, 'student/login', 'post', formData, null, true).then(
      (responseData) => {
        localStorage.setItem('token', responseData.api_token);
        localStorage.setItem('login_type', 'student');
        localStorage.setItem('fname', responseData.fname);
        localStorage.setItem('lname', responseData.lname);
        context.commit('setUser', {
          user_settings: responseData.user_settings,
          token: responseData.api_token,
          fname: responseData.fname,
          lname: responseData.lname,
          email: responseData.email,
          school: responseData.school,
          prework: responseData.prework,
          experiences: responseData.experiences,
          settings: responseData.settings,
          notifications: responseData.notifications,
          available_experiences: responseData.available_experiences,
          certificate_teachers: responseData.certificate_teachers,
          ctWhsEnabled: responseData.ct_whs_enabled,
        });
        window.location.href = '/student/dashboard';
      },
      () => {},
    );
  },
  async tryLogin(context) {
    const appLoading = document.getElementById('loading-bg-full');
    appLoading.style.display = 'block';

    return new Promise((resolve, reject) => {
      const loginType = localStorage.getItem('login_type');
      const token = localStorage.getItem('token');
      if (loginType != 'student' || token.length == 0) {
        localStorage.removeItem('token');
        localStorage.removeItem('login_type');
        localStorage.removeItem('fname');
        localStorage.removeItem('lname');
        reject();
      }
      axios.post($vjeConfig.VUE_APP_API_URL + 'student/checkToken').then(
        (response) => {
          const responseData = response.data;
          // The data is available now. Finally we can commit something
          if (responseData.status == 'OK') {
            context.commit('setUser', {
              userID: responseData.student_id,
              token: responseData.api_token,
              fname: responseData.fname,
              lname: responseData.lname,
              email: responseData.email,
              school: responseData.school,
              prework: responseData.prework,
              experiences: responseData.experiences,
              settings: responseData.settings,
              notifications: responseData.notifications,
              available_experiences: responseData.available_experiences,
              certificate_teachers: responseData.certificate_teachers,
              user_settings: responseData.user_settings,
              ctWhsEnabled: responseData.ct_whs_enabled,
            });
            localStorage.setItem('fname', responseData.fname);
            localStorage.setItem('lname', responseData.lname);
            appLoading.style.display = 'none';
            resolve();
          } else {
            appLoading.style.display = 'none';
            localStorage.removeItem('token');
            localStorage.removeItem('login_type');
            localStorage.removeItem('fname');
            localStorage.removeItem('lname');
            reject();
          }
        },
        () => {
          appLoading.style.display = 'none';
          localStorage.removeItem('token');
          localStorage.removeItem('login_type');
          localStorage.removeItem('fname');
          localStorage.removeItem('lname');
          reject();
        },
      );
    });
  },
  async logout(context) {
    const res = await theApi.methods.makeCall(false, 'logout', 'post');
    localStorage.removeItem('token');
    localStorage.removeItem('login_type');
    localStorage.removeItem('fname');
    localStorage.removeItem('lname');
    context.commit('setUser', {
      userID: '',
      token: '',
      email: '',
      fname: '',
      lname: '',
      prework: false,
      experiences: [],
      active_experience_id: false,
      settings: false,
      notifications: [],
      available_experiences: [],
      certificate_teachers: false,
      user_settings: [],
    });
    window.location.href = res.url;
  },

  /***
   *  PREWORK FUNCTIONS
   */
  async removeWorkplaceSafetyCertificate(context) {
    theApi.methods.makeCall(false, 'workplace_safety/removeCertificate', 'post').then(
      () => {
        context.commit('preworkRemoveWSCert');
      },
      () => {},
    );
  },
  async removeWorkplaceSafetyCertificateOther(context, payload) {
    const formData = new FormData();
    formData.append('name', payload);
    theApi.methods
      .makeCall(false, 'workplace_safety/removeCertificateOther', 'post', formData, null, true)
      .then(
        () => {
          context.commit('preworkRemoveWSCertOther', payload);
        },
        () => {},
      );
  },

  /***
   *  ACTIVE VJE FUNCTIONS
   */
  async startExperience(context, payload) {
    const formData = new FormData();
    formData.append('vje_id', payload);
    theApi.methods.makeCall(false, 'experiences/start', 'post', formData, null, true).then(
      (data) => {
        //Remove current experience - we don't keep closed experiences in state
        //Add experience object to other experiences
        store.commit('authStudent/addExperience', data.experience);
        //Set active experience id
        store.commit('authStudent/setActiveExperienceID', data.active_experience_id);

        store.dispatch('authStudent/completeIntro', {
          student_vje_id: data.active_experience_id,
        });
        router.push('/student/work-experience-router');
      },
      () => {},
    );
  },
  async restartExperience(context, payload) {
    const formData = new FormData();
    formData.append('student_vje_id', payload);
    theApi.methods.makeCall(false, 'experiences/restart', 'post', formData, null, true).then(
      (data) => {
        //Remove current experience - we don't keep closed experiences in state
        store.commit('authStudent/removeActiveExperience');
        //Add experience object to other experiences
        const experience_data = {
          id: payload,
          data: data.experience,
        };
        store.commit('authStudent/modifyExperience', experience_data);
        //Set active experience id
        store.commit('authStudent/setActiveExperienceID', data.active_experience_id);
        router.push('/student/work-experience/' + payload + '/tour_and_induction');
      },
      () => {},
    );
  },
  async addRealWorldExperience(context, payload) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
      formData.append(key, value);
    }
    theApi.methods
      .makeCall(false, 'experiences/realworld_start', 'post', formData, null, true)
      .then(
        (data) => {
          //Remove current experience - we don't keep closed experiences in state
          //store.commit('authStudent/removeActiveExperience');
          //Add experience object to other experiences
          store.commit('authStudent/addExperience', data.experience);
          //Set active experience id
          //store.commit('authStudent/setActiveExperienceID', data.active_experience_id);
          router.push('/student/reflection/in-person');
        },
        () => {},
      );
  },
  async completeIntro(context, payload) {
    theApi.methods.makeCall(false, 'experiences/completeIntro', 'post', payload, null, true).then(
      (data) => {
        if (data.status == 'OK') {
          //Mark active experience as intro completed
          const experience_data = {
            id: payload.student_vje_id,
            data: data.data,
          };
          store.commit('authStudent/modifyExperience', experience_data);
          router.push(
            '/student/work-experience/' +
              context.getters.activeExperienceID +
              '/tour_and_induction',
          );
        }
      },
      () => {},
    );
  },
  completePreworkSection(context, payload) {
    context.commit('completePreworkSection', payload);
  },
  markLastNotificationsRead(context, numUnread) {
    const formData = new FormData();
    formData.append('num_unread', numUnread);

    theApi.methods.makeCall(false, 'notifications/mark_read', 'post', formData).then(
      () => {
        store.commit('authStudent/markNotificationsRead', numUnread);
      },
      () => {},
    );
  },
  clearNotifications() {
    theApi.methods.makeCall(false, 'notifications/clear', 'post').then(
      () => {
        store.commit('authStudent/setNotifications', []);
      },
      () => {},
    );
  },
  markNotificationRead(context, nID) {
    const formData = new FormData();
    formData.append('notification_id', nID);
    theApi.methods.makeCall(false, 'notifications/mark_notification_read', 'post', formData).then(
      () => {
        store.commit('authStudent/markNotificationRead', nID);
      },
      () => {},
    );
  },
  deleteNotification(context, nID) {
    const formData = new FormData();
    formData.append('notification_id', nID);
    theApi.methods.makeCall(false, 'notifications/delete_notification', 'post', formData).then(
      () => {
        store.commit('authStudent/deleteNotification', nID);
      },
      () => {},
    );
  },
  deleteNotifications() {
    theApi.methods.makeCall(false, 'notifications/delete_all_notifications', 'post').then(
      () => {
        store.commit('authStudent/deleteNotifications');
      },
      () => {},
    );
  },
};
